import { toast } from 'react-toastify';

// DRF 필드 에러({ field_name: ['message', ...] })에서 첫 메시지 추출
const extractFirstFieldError = data => {
  for (const value of Object.values(data)) {
    if (Array.isArray(value) && typeof value[0] === 'string') {
      return value[0];
    }
  }
  return null;
};

export const extractApiErrorMessage = error => {
  const data = error?.response?.data;
  if (!data) return null;
  if (typeof data === 'string') return data;
  if (Array.isArray(data)) {
    return typeof data[0] === 'string' ? data[0] : null;
  }

  return (
    data?.lines?.non_field_errors?.[0] ??
    data?.non_field_errors?.[0] ??
    data?.detail ??
    extractFirstFieldError(data)
  );
};

export const toastApiError = (error, fallbackMessage) => {
  // 429 is already toasted by the global httpClient interceptor
  if (error?.response?.status === 429) return;

  toast.error(extractApiErrorMessage(error) || fallbackMessage);
};
